/**
 * Hero 区 · 首屏强工具入口版
 *
 * 视觉结构（自上而下）：
 *  ① 深蓝色块：品牌 + 主标题 + 价值文案 + 信任三联 + 紧凑倒计时
 *  ② 白色 ScoreInputCard（-mt-5 上压）：首屏可见的分数输入入口
 *
 * 不再包含「栏目导航」和「倒计时大条」——
 *  - 栏目导航摘到 <StickyNav>，挂在 hero 下方，滚动时吸顶
 *  - 倒计时压缩成 hero 底部一行小字
 *
 * 设计语气：白纸 + 深蓝印刷 + 古铜金 accent + 衬线标题
 */
import type { StageInfo } from '@/domain/stage'
import { ScoreInputCard } from './ScoreInputCard'
import { HeatBadge } from './HeatStrip'

export function HeroBanner({ stageInfo }: { stageInfo: StageInfo }) {
  return (
    <header>
      {/* ── ① 深蓝主张层 ── */}
      <div className="bg-gradient-to-b from-brand-900 to-brand-800 text-white pt-8 pb-10">
        <div className="container-mobile">
          {/* 品牌行 */}
          <div className="flex items-center gap-3 mb-6">
            <img
              src="/logo_1.png"
              alt="方法星球"
              className="h-10 w-10 rounded-lg shadow-soft bg-white p-1"
            />
            <div>
              <div className="text-white text-base font-medium leading-tight">方法星球</div>
              <div className="text-brand-200 text-xs leading-tight">卓越教育 · 公益项目</div>
            </div>
          </div>

          {/* 主标题 + 价值文案 */}
          <div className="text-brand-200 text-[11px] tracking-widest mb-2">
            ─── 邹城家长公益项目 · 完全免费 ───
          </div>
          <h1 className="font-serif text-[32px] leading-tight tracking-tight mb-2">
            邹城中考志愿填报工具
          </h1>
          <p className="text-white text-[14px] leading-relaxed mb-4">
            <span className="text-accent-400 font-medium">输入分数</span>
            <span className="text-brand-200">，</span>
            <span className="font-medium">3 秒</span>
            <span className="text-brand-200">得到邹城五校的</span>
            <span className="font-medium">录取概率区间</span>
            <span className="text-brand-200">与</span>
            <span className="font-medium">「冲 / 稳 / 保」</span>
            <span className="text-brand-200">建议</span>
          </p>

          {/* 信任三联 */}
          <div className="flex items-center gap-4 text-brand-200 text-[11px] mb-4">
            <span className="flex items-center gap-1">
              <span className="text-accent-400">✓</span> 完全免费
            </span>
            <span className="flex items-center gap-1">
              <span className="text-accent-400">✓</span> 数据本地计算
            </span>
            <span className="flex items-center gap-1">
              <span className="text-accent-400">✓</span> 不收集隐私
            </span>
          </div>

          {/* 真实热度（社交证明）·数据不足时自动隐藏 */}
          <HeatBadge />
        </div>
      </div>

      {/* ── ② 白色分数输入卡（-mt 上压在 hero 下边沿，首屏可见）── */}
      <div className="bg-paper-50">
        <div className="container-mobile -mt-6">
          <ScoreInputCard stageInfo={stageInfo} />
        </div>
      </div>
    </header>
  )
}
